import atlasApi				from "../utils/atlasapi";


// Bridges the WorkOS AuthKit session (set by AuthGate) into the plain-JS
// world. getUser() keeps the old Azure clientPrincipal shape
// ({userId, userDetails, userRoles, identityProvider}) so the ~14 existing
// consumers stay unchanged.
class authApi {

	workosUser = null;
	workosSignOut = null;

	constructor() {
		if (authApi.instance) {
			return authApi.instance;
		}
		authApi.instance = this;
		return this;
	}

	setWorkosAuth({ user, signOut }){
		this.workosUser = user;
		this.workosSignOut = signOut;
	}

	signOut(){
		// returnTo makes the SDK redirect even when it considers the session
		// already inactive (otherwise it throws instead of navigating).
		if(this.workosSignOut)
			this.workosSignOut({ returnTo: window.location.origin });
	}

	async getUser(){

		if(!this.workosUser)
			return undefined;

		const user = {
			identityProvider: "workos",
			userId: this.workosUser.id,
			userDetails: this.workosUser.email,
			userRoles: ["user", "authenticated"],
			firstName: this.workosUser.firstName,
			lastName: this.workosUser.lastName
		};

		let settings = await atlasApi.getSettings(user).catch(() => null);
		if(!settings)
			settings = {
				"areaUnit": "meter",
				"filters": {},
				"turbineStyles": {},
				"recentProjects": []
			};

		return {
			...user,
			settings: settings
		};
	}

};

export default new authApi();
